'use client';

import { c as _c } from "react/compiler-runtime";
import { Checkbox, Skeleton } from '@common/components';
interface FilterCheckboxListProps<T extends string | number> {
  options: {
    value: T;
    label: string;
  }[];
  selectedValues: T[];
  onToggle: (value: T) => void;
  emptyLabel?: string;
  isLoading?: boolean;
  skeletonCount?: number;
}
export function FilterCheckboxList(t0) {
  const $ = _c(13);
  const {
    options,
    selectedValues,
    onToggle,
    emptyLabel: t1,
    isLoading: t2,
    skeletonCount: t3
  } = t0;
  const emptyLabel = t1 === undefined ? "\uC120\uD0DD \uAC00\uB2A5\uD55C \uD56D\uBAA9\uC774 \uC5C6\uC2B5\uB2C8\uB2E4." : t1;
  const isLoading = t2 === undefined ? false : t2;
  const skeletonCount = t3 === undefined ? 5 : t3;
  if (isLoading) {
    let t4;
    if ($[0] !== skeletonCount) {
      t4 = <>{Array.from({
          length: skeletonCount
        }, _temp)}</>;
      $[0] = skeletonCount;
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    return t4;
  }
  if (options.length < 1) {
    let t4;
    if ($[2] !== emptyLabel) {
      t4 = <p className="text-Gray-600 typo-body4">{emptyLabel}</p>;
      $[2] = emptyLabel;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    return t4;
  }
  let t4;
  if ($[4] !== onToggle || $[5] !== options || $[6] !== selectedValues) {
    let t5;
    if ($[8] !== onToggle || $[9] !== selectedValues) {
      t5 = option => <Checkbox key={String(option.value)} checked={selectedValues.includes(option.value)} onCheckedChange={() => onToggle(option.value)}><span className="text-Gray-800 typo-body4">{option.label}</span></Checkbox>;
      $[8] = onToggle;
      $[9] = selectedValues;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = options.map(t5);
    $[4] = onToggle;
    $[5] = options;
    $[6] = selectedValues;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <>{t4}</>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp(_, index) {
  return <div key={index} className="flex items-start gap-4 p-4"><Skeleton className="m-2 size-16 shrink-0 rounded-xxsmall" /><Skeleton className="h-21 w-3/5 rounded-xxsmall" /></div>;
}